<template lang="pug">
	.customer-invoices-list.flex-col.space
		ListView.full-width(ref="listView", initialView="table", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => prepareData(r.Results)", :getData="$Data.getCustomerInvoices", :columns="columns")
			template(v-slot:oid-template="{ data }")
				.flex-row.space-medium.align-center
					span {{data.InvoiceNumber}}
					a(:title="$tCaption('Open PDF')" @click="viewingInvoice = data")
						i.invoice-button.fas.fa-search
					Loader(v-if="downloadingInvoices.includes(data.Oid)", text="")
					a(v-else, :title="$tCaption('Download')", @click="downloadPdf(data)")
						i.invoice-button.fas.fa-download
					DxButton(v-if="data.CanBePaid && (data.Status === 0 || data.Status === 2)" :text="$tCaption('Pay')", @click.prevent="pay(data.Oid)")
			template(v-slot:status-template="{ data }")
				.flex-col.status-name
					span {{data.StatusName()}}
					.product-activation-status.font-tiny.grey {{activationStatuses[data.ProductsActivationStatus || 0] && activationStatuses[data.ProductsActivationStatus || 0].name}}
		Popup(v-if="viewingInvoice", :popupVisible="!!viewingInvoice", :width="840", :height="1100", @hiding="viewingInvoice = null")
			.customer-invoices-list.flex-row.center
				PdfViewer.pdf-viewer(:src="viewSrc")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close')", @click="viewingInvoice = null")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import ListView from 'app-core/ListView.vue';
	import Popup from 'app-core/Popup.vue';
	import PdfViewer from 'app-core/PdfViewer.vue';
	import { PRODUCT_ACTIVATION_STATUSES } from 'app-core/constants';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'company.CustomerInvoicesList',
		name: 'customer-invoices-list',
		components: {
			ListView, DxButton, Popup, PdfViewer, Loader
		},
		props: ['company'],
		data() {
			return {
				columns: [
					{ dataField: 'Oid', caption: () => this.$tCaption('Invoices'), cellTemplate: 'oid-template' },
					{ dataField: 'StatusName', caption: () => this.$tCaption('Status'), cellTemplate: 'status-template' },
					{ dataField: 'Description', caption: () => this.$tCaption('Subscription') },
					{ dataField: 'Date', caption: () => this.$tCaption('Date'), dataType: 'date' },
					{ dataField: 'PayedDate', caption: () => this.$tCaption('Paid date'), dataType: 'date' },
					{ dataField: 'Gross', caption: () => this.$tCaption('Gross'), calculateCellValue: (row) => this.$formatCell(row, 'Gross', 'currency')  },
					{ dataField: 'Subtotal', caption: () => this.$tCaption('Subtotal'), calculateCellValue: (row) => this.$formatCell(row, 'Subtotal', 'currency') },
					{ dataField: 'Tax', caption: () => this.$tCaption('Tax'), calculateCellValue: (row) => this.$formatCell(row, 'Tax', 'currency') },
					{ dataField: 'SalesTax', caption: () => this.$tCaption('Sales tax'), calculateCellValue: (row) => this.$formatCell(row, 'SalesTax', 'percent') },
					{ dataField: 'Discount', caption: () => this.$tCaption('Discount'), calculateCellValue: (row) => this.$formatCell(row, 'Discount', 'percent') },
					{ dataField: 'Total', caption: () => this.$tCaption('Total'), calculateCellValue: (row) => this.$formatCell(row, 'Total', 'currency') },
				],
				invoiceStatuses: [
                    () => this.$tCaption('Unpaid'),
                    () => this.$tCaption('Paid'),
                    () => this.$tCaption('PastDue'),
                ],
				viewingInvoice: null,
				activationStatuses: PRODUCT_ACTIVATION_STATUSES.toLocale('name', this),
				downloadingInvoices: []
			};
		},
		computed: {
			viewSrc() {
				return this.$Data.getMethodUrl(`externalApi?embedded=true&accessToken=${this.$auth.accessToken()}&method=CustomerInvoice/DownloadPdfInvoice&parameters=${encodeURIComponent(`invoiceId=${this.viewingInvoice.Oid}`)}`);
			},
		},
		methods: {
			async downloadPdf(invoice) {
				if (this.downloadingInvoices.includes(invoice.Oid)) return;
				this.$Data.toggleSelectedIdInArray(invoice.Oid, this.downloadingInvoices);
				this.$Data.downloadCustomerInvoice(invoice.Oid).then(data => {
					var link = document.createElement('a');
					link.href = window.URL.createObjectURL(data);
					link.download = `Invoice n${invoice.InvoiceNumber}.pdf`;
					link.click();
				}).finally(() => this.$Data.toggleSelectedIdInArray(invoice.Oid, this.downloadingInvoices));
			},
			prepareData(data) {
				return (data || []).map(f => ({
					...f, 
					StatusName: this.invoiceStatuses[f.Status],
					PayedDate: new Date(f.PayedDate) < new Date(2,1,1901) ? null : f.PayedDate
				}));
			},
			pay(invoiceId) {
				this.$router.push({
					path: '/pay',
					query: {
						invoiceId,
						tokenId: this.company.Oid,
					}
				})
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.customer-invoices-list {
		.pdf-viewer {
			width: 816px;
			height: 1000px;
		}

		.invoice-button {
			color: #bdbdbd;
			font-size: 16px;
			cursor: pointer;

			&:hover {
				color: $base-accent;
			}
		}

		.button {
			padding: 6px 18px;
			border-radius: 4px;
			text-align: center;
			text-transform: uppercase;
			font-size: 0.8em;
			cursor: pointer;
			color: #fff;

			&.error {
				background: #ff5b5b;
			}

			&.action {
				background: #50a3ff;
			}
		}

		.status-name {
			position: relative;

			.product-activation-status {
				position: absolute;
				bottom: -12px;
			}
		}
	}
</style>
